import React, {useEffect} from 'react';
import scrollIntoView from 'scroll-into-view-if-needed';
import OnboardingNew from '../../stories/components/OnboardingNew/OnboardingNew';
import {logPageLoadEvents} from '@ibibo/analytics';
import {updatePreviousPageName} from '../../store/actions';
import {changeCountryCode} from '../../store/actions/onboarding';
import {useSelector, useDispatch} from 'react-redux';
import {prevPageNameSelector, mpnfoSelector} from '../../store/selectors';
import {
  getCrid,
  returnNewCrid,
  updateUrlWithNewCrid,
} from '../../../../myaccount/src/utils/redirectWithCrId';
import SlickMinStyle from './slick.min';
import SlickThemeStyle from './slick-theme.min';
import {Helmet} from 'react-helmet';
import {faqData, lobFAQData} from './../../stories/components/OnboardingNew/FooterBlock/faqData';
import {lobSelector} from './../../store/selectors';
import init from 'MMT-UI/init';

const HomePageNew = () => {
  const lob = useSelector(lobSelector);
  let isIndia = true;

  const setCookie = (cookieName, cookieValue, cookieExdays, domain) => {
    var d = new Date();
    d.setTime(d.getTime() + cookieExdays * 24 * 60 * 60 * 1000);
    var expires = 'expires=' + d.toUTCString();
    document.cookie = cookieName + '=' + cookieValue + ';' + expires + `;path=/; domain=.${domain}`;
  };
  useEffect(() => {
    scrollIntoView(document.getElementById('onboardingnew'), {
      block: 'start',
      behavior: 'auto',
    });

    dispatch(changeCountryCode(false));
    updateUrlWithNewCrid();

    init(); // Setting up dvid cookie
  }, []);

  const data = useSelector(prevPageNameSelector);
  const {prevPageName = ''} = data;
  const dispatch = useDispatch();

  useEffect(() => {
    const events = {
      eVar23: prevPageName,
      eVar24: 'onboarding|mypartner',
      eVar37: 'domain_sbu:india|domain_country:in|domain_currency:inr|domain_language:eng',
      // eVar107: `mpnfo_${mpnfoValue}`,
    };
    logPageLoadEvents('onboarding:signup:landing', events);
    dispatch(updatePreviousPageName('onboarding:signup:landing'));
  }, [dispatch]);
  const faqSchema = () => {
    let schemaObj = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: [],
    };
    const footerFaqData =
      lobFAQData && lobFAQData[lob] && lobFAQData[lob]['data'] ? lobFAQData[lob]['data'] : faqData;

    if (!footerFaqData) {
      return schemaObj;
    }
    footerFaqData.forEach(data => {
      schemaObj['mainEntity'].push({
        '@type': 'Question',
        name: data?.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: data?.answerList?.join(''),
        },
      });
    });

    return schemaObj;
  };

  const productSchema = {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: 'myPartner',
    image: '',
    brand: {
      '@type': 'Brand',
      name: 'MakeMyTrip',
    },
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: '4.5',
      ratingCount: '2020000',
    },
  };

  let href = `https://mypartner.makemytrip.com/`;
  if (lob) {
    href += `${lob}`;
  }

  const linkArray = [
    {
      rel: 'canonical',
      href: href,
    },
  ];
  const faqSchemaData = faqSchema();
  let title = isIndia
    ? 'B2B Travel Booking Portal for Travel Agents in India'
    : 'Best B2B Booking Portal for Travel Agents - myPartner';
  let description =
    'myPartner, a b2b travel portal built exclusively for travel agents to fulfill all customer travel needs. ✅ 60,000+ Travel Agents ✅ Easy To Use ✅ Best Deals.';
  if (lob?.toLowerCase() === 'hotel') {
    title = 'B2B Hotel Booking Portal for Travel Agents in India - myPartner';
    description =
      'Find the best deals on b2b hotel bookings through the best travel agent portal. Simplify your hotel booking process and save time with myPartner Platform.';
  }
  if (lob?.toLowerCase() === 'flight') {
    title = 'B2B Flight Booking Portal for Travel Agents in India - myPartner';
    description =
      'Find the best deals on b2b flight bookings through the best travel agent portal. Simplify your air ticket booking process and save time with our platform.';
  }

  return (
    <>
      <Helmet
        title={title}
        meta={[
          {
            name: 'description',
            content: description,
          },
          {
            name: 'og:title',
            content: title,
          },
        ]}
        link={linkArray}
      >
        <script type="application/ld+json">{JSON.stringify(faqSchemaData)}</script>
        <script type="application/ld+json">{JSON.stringify(productSchema)}</script>
      </Helmet>
      <SlickMinStyle />
      <SlickThemeStyle />
      <OnboardingNew step={0}>{/* <OtpVerify /> */}</OnboardingNew>
    </>
  );
};

export default HomePageNew;
